import { useEffect, useRef } from "react";

// Pilha global de "voltar com ESC". Cada modal/overlay aberto se registra no
// topo da pilha; quando ESC é pressionado, só o handler do topo dispara —
// e o evento é marcado como tratado (preventDefault) para que listeners
// genéricos (ex.: o do ChatFloating) não fechem tudo de uma vez.
const stack: Array<() => void> = [];

if (typeof window !== "undefined") {
  window.addEventListener(
    "keydown",
    (e) => {
      if (e.key !== "Escape" || e.defaultPrevented) return;
      const top = stack[stack.length - 1];
      if (!top) return;
      e.preventDefault();
      e.stopPropagation();
      top();
    },
    true, // capture: roda antes de listeners em fase de bubble
  );
}

export function useEscape(active: boolean, onEscape: () => void) {
  const ref = useRef(onEscape);
  ref.current = onEscape;
  useEffect(() => {
    if (!active) return;
    const wrapped = () => ref.current();
    stack.push(wrapped);
    return () => {
      const i = stack.lastIndexOf(wrapped);
      if (i >= 0) stack.splice(i, 1);
    };
  }, [active]);
}
